import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { AppConstants } from './app.constants';
import { environment } from '../../environments/environment';
var UserService = /** @class */ (function () {
    function UserService(http, auth, appConstants) {
        this.http = http;
        this.auth = auth;
        this.appConstants = appConstants;
    }
    UserService.prototype.getUserData = function (userId) {
        return this.http.get(environment.apiBase + ("freelancers/" + userId), { headers: this.auth.getAuthorizationHeaders() })
            .map(function (r) { return r; })
            .catch(this.appConstants.errorHandler);
    };
    return UserService;
}());
export { UserService };



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shared/user.service.ts.pre-build-optimizer.js